module.exports = __webpack_public_path__ + "static/world-placeholder-a2d25dec7e959e05f4a2ae0998496c31.jpg";